export default Object.freeze({
  POLICY_EXCESS: 'POL_EXCESS',
  MEMBER_EXCESS: 'MEM_EXCESS',
});
